import styled from 'styled-components';

export const CompanyInfoContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
`;

export const CompanyInfoTitle = styled.div`
    font-size: 1.4rem;
    color: black;
    margin-left: 10px;
    margin-right: 10px;
`;

export const CompanyInfoAvaliation = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    width: 45px;
    background-color: #dbdbdb;
    border-radius: 22.5px;
    font-size: 1.2rem;
    font-weight: bold;
`;

export const StatusIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    padding-left: 5px;
    color: ${props => (props.status ? 'green': 'red')};
`;
